import { __assign, __rest } from "tslib";
import React, { useEffect, useRef, useImperativeHandle } from "react";
import classNames from "classnames";
import { useConfig } from "../util";
import { useDefaultValue } from "../form";
import { forwardRefWithStatics } from "../_util/forward-ref-with-statics";
import { MonacoDiffEditor } from "./MonacoDiffEditor";
import { useIsomorphicLayoutEffect } from "../_util/use-isomorphic-layout-effect";
export var MonacoEditor = forwardRefWithStatics(function MonacoEditor(_a, ref) {
    var monaco = _a.monaco, _b = _a.options, options = _b === void 0 ? {} : _b, language = _a.language, className = _a.className, style = _a.style, width = _a.width, height = _a.height, props = __rest(_a, ["monaco", "options", "language", "className", "style", "width", "height"]);
    var classPrefix = useConfig().classPrefix;
    var _c = useDefaultValue(props, ""), value = _c.value, onChange = _c.onChange;
    var containerRef = useRef(null);
    var editorRef = useRef(null);
    var changeEventRef = useRef(null);
    // https://github.com/react-monaco-editor/react-monaco-editor/blob/master/src/editor.js
    var preventTriggerChangeEvent = useRef(false);
    useEffect(function () {
        if (editorRef.current) {
            editorRef.current.layout();
        }
    }, [width, height]);
    useEffect(function () {
        if (editorRef.current) {
            var model = editorRef.current.getModel();
            monaco.editor.setModelLanguage(model, language);
        }
    }, [language, monaco]);
    useEffect(function () {
        if (editorRef.current) {
            var editor = editorRef.current;
            var model = editor.getModel();
            if (value != null && value !== model.getValue()) {
                preventTriggerChangeEvent.current = true;
                editor.pushUndoStop();
                model.pushEditOperations([], [
                    {
                        range: model.getFullModelRange(),
                        text: value,
                    },
                ], undefined);
                editor.pushUndoStop();
                preventTriggerChangeEvent.current = false;
            }
        }
    }, [value, monaco]);
    useIsomorphicLayoutEffect(function () {
        var editor = monaco.editor.create(containerRef.current, __assign(__assign({}, options), { value: value,
            language: language }));
        editorRef.current = editor;
        changeEventRef.current = editor.onDidChangeModelContent(function (event) {
            if (!preventTriggerChangeEvent.current) {
                onChange(editor.getValue(), { event: event });
            }
        });
        return function () {
            editorRef.current.dispose();
            var model = editorRef.current.getModel();
            if (model) {
                model.dispose();
            }
            if (changeEventRef.current) {
                changeEventRef.current.dispose();
            }
        };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    useImperativeHandle(ref, function () { return ({
        editor: editorRef.current,
    }); });
    return (React.createElement("div", { className: classNames(classPrefix + "-monaco-editor-container", className), style: __assign(__assign({}, (style || {})), { height: height || "100%", width: width || "100%" }), ref: containerRef }));
}, {
    DiffEditor: MonacoDiffEditor,
});
MonacoEditor.displayName = "MonacoEditor";
//# sourceMappingURL=MonacoEditor.js.map